import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Spinner } from "react-bootstrap";
import BreadcrumbsSection from "../breadcrumbs/BreadcrumbsSection";
import SelectDropDown from "../selectdropdown/SelectDropDown";
import { components } from "react-select";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTable from "../datatables/CardLessDataTableWithSearch";
import moment from "moment";
import { scopeBranches } from "../../../utils/branchScope";
import "./_employeeAttendance.scss";

const ADD_ATTENDANCE = gql`
  mutation ($params: EmployeeAttendance!) {
    addEmployeeAttendanceData(params: $params) {
      success
      message
    }
  }
`;

const GET_EMPLOYEE_ROLES = gql`
  query($institute_id: Int) {
    getEmployeeRoles(institute_id: $institute_id) {
      id
      role_name
    }
  }
`;

class EmployeeAttendanceSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branchError: "",
      role: "",
      roleError: "",
      employee_roles: [],
      defaultvalue: 0,
      getEmployeesAttendanceStatus: [],
      loadingSpinner: 0,
      currentStep: 1,

      currentDate: new Date().toISOString().slice(0, 10),
      date: new Date().toISOString().slice(0, 10),

      totalEmployees: 0,
      presentEmployees: 0,
      absentEmployees: 0,
      halfDayEmployees: 0,
      is_submit: false,

      // inline confirmation step
      view: "mark", // "mark" | "confirm"
      saving: false,
      saved: false,
      saveError: "",
      selectedBulkMark: 1,
    };
  }
  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(
      {
        [name]: value,
        branchError: "",
        roleError: "",
        getEmployeesAttendanceStatus: [],
        is_submit: false,
        selectedBulkMark: 1,
      },
      () => { },
    );
  };

  componentDidMount() {
    this.getEmployeeRoles();
  }

  getEmployeeRoles = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_EMPLOYEE_ROLES,
        variables: { institute_id: parseInt(Cookies.get("institutionid")) },
        fetchPolicy: "network-only",
      });
      this.setState({ employee_roles: (result.data && result.data.getEmployeeRoles) || [] });
    } catch {
      this.setState({ employee_roles: [] });
    }
  };

  // The branches to mark attendance for: the header's selection (NavbarOne),
  // narrowed to the branches this user is authorized for.
  scopedBranchIds = () =>
    scopeBranches(this.props.globals?.globalBranches || []).map((b) => parseInt(b.id));

  getEmployeesAttendanceStatus = async () => {
    // getEmployeesAttendanceStatus takes a single branch_id, so fan the query out
    // across the header's branch scope and concatenate the employee lists.
    const branchIds = this.scopedBranchIds();
    if (branchIds.length === 0) {
      this.setState({ branchError: "No branch in scope — pick one in the header" });
      return "";
    }
    // if (!this.state.role || this.state.role == 0) {
    //   this.setState({ roleError: "Please select role" });
    //   return "";
    // }

    this.setState({ loadingSpinner: 1, branchError: "" });

    const results = await Promise.all(branchIds.map((branch_id) => this.props.client.query({
      query: gql`
        query ($institute_id: Int, $branch_id: Int, $date: String) {
          getEmployeesAttendanceStatus(
            institute_id: $institute_id
            branch_id: $branch_id
            date: $date
          ) {
            emp_mobile
            employee_name
            attendance_status
            employee_id
            employee_type
          }
        }
      `,
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: branch_id,
        date: moment(this.state.date, "YYYY-MM-DD").unix().toString(),
        emp_role_id: parseInt(this.state.role),
      },
    })));

    const employees = results.flatMap((r) => (r.data && r.data.getEmployeesAttendanceStatus) || []);

    if (employees.length > 0) {
      let employeesData = [];
      employees.map((item) => {
        let label = "Present";
        const statusVal = parseInt(item.attendance_status);
        if (statusVal === 1) {
          label = "Present";
        } else if (statusVal === 0) {
          label = "Leave";
        } else if (statusVal === 2) {
          label = "Half Day";
        }
        employeesData.push({
          ...item,
          value: isNaN(statusVal) ? 1 : statusVal,
          label,
        });
      });

      let totalEmployees = employeesData.length;
      let no_of_emp_present = employeesData.filter(
        (item) => item.value == 1,
      ).length;
      let no_of_emp_Absent = employeesData.filter(
        (item) => item.value == 0,
      ).length;
      let no_of_emp_halfDay = employeesData.filter(
        (item) => item.value == 2,
      ).length;

      this.setState({
        getEmployeesAttendanceStatus: employeesData,
        loadingSpinner: 0,
        is_submit: true,
        presentEmployees: no_of_emp_present,
        absentEmployees: no_of_emp_Absent,
        halfDayEmployees: no_of_emp_halfDay,
        totalEmployees: totalEmployees,
        selectedBulkMark: 1,
      });
    } else {
      this.setState({
        getEmployeesAttendanceStatus: [],
        loadingSpinner: 0,
        is_submit: true,
        selectedBulkMark: 1,
      });
    }
  };

  selDate = (e) => {
    this.setState({
      date: e.target.value,
      getEmployeesAttendanceStatus: [],
      is_submit: false,
      selectedBulkMark: 1,
    });
  };

  handleConfirmSave = async () => {
    this.setState({ saving: true, saveError: "" });

    const employee_attendance = this.state.getEmployeesAttendanceStatus.map(
      (item) => ({
        employee_id: item.employee_id,
        attendance_status: parseInt(item.value),
      }),
    );
    const params = {
      inserted_time: moment(this.state.date, "YYYY-MM-DD").unix().toString(),
      inserted_by: parseInt(Cookies.get("id")),
      employee_attendance,
    };

    try {
      const { data } = await this.props.client.mutate({
        mutation: ADD_ATTENDANCE,
        variables: { params },
      });

      if (data && data.addEmployeeAttendanceData) {
        this.setState({ saved: true });
        setTimeout(() => {
          window.location.reload(false);
        }, 1200);
      } else {
        this.setState({
          saving: false,
          saveError: "Failed to save attendance. Please try again.",
        });
      }
    } catch (error) {
      const msg =
        error.graphQLErrors && error.graphQLErrors.length
          ? error.graphQLErrors.map((x) => x.message).join(", ")
          : "Failed to save attendance.";
      this.setState({ saving: false, saveError: msg });
    }
  };

  present(cell, row, rowIndex, formatExtraData) {
    const attendance_status = [
      { value: 0, label: "Leave" },
      { value: 1, label: "Present" },
      { value: 2, label: "Half Day" },
    ];
    const attendedStatus = this.state.getEmployeesAttendanceStatus.filter(
      (item) => item.emp_mobile == row.emp_mobile,
    );
    const current = attendedStatus[0] ? attendedStatus[0].value : 1;
    const colorMap = { 1: "#10b981", 0: "#ef4444", 2: "#f59e0b" };
    const color = colorMap[current] || "#10b981";
    return (
      <select
        className="form-control"
        value={current}
        onChange={(e) => this.presentOrAbsent(e, row)}
        style={{
          maxWidth: 160,
          margin: "0 auto",
          display: "block",
          textAlignLast: "center",
          border: `1.5px solid ${color}`,
          color,
          fontWeight: 700,
          fontSize: 13,
          borderRadius: 8,
          padding: "6px 10px",
          cursor: "pointer",
        }}
      >
        {attendance_status.map((item) => (
          <option key={item.value} value={item.value} style={{ color: "#0f172a" }}>
            {item.label}
          </option>
        ))}
      </select>
    );
  }

  presentOrAbsent(e, row) {
    console.log("rowwwwwwwwwwwwwwwww", e.target.value, row);

    const val = parseInt(e.target.value);
    let label = "Present";
    if (val === 0) label = "Leave";
    else if (val === 2) label = "Half Day";

    const employeeAttendanceData = this.state.getEmployeesAttendanceStatus.map(
      (item) => {
        if (item.emp_mobile == row.emp_mobile) {
          return { ...item, value: val, label };
        } else {
          return { ...item };
        }
      },
    );

    let totalEmployees = employeeAttendanceData.length;
    let no_of_emp_present = employeeAttendanceData.filter(
      (item) => item.value == 1,
    ).length;
    let no_of_emp_Absent = employeeAttendanceData.filter(
      (item) => item.value == 0,
    ).length;
    let no_of_emp_halfDay = employeeAttendanceData.filter(
      (item) => item.value == 2,
    ).length;

    this.setState({
      getEmployeesAttendanceStatus: employeeAttendanceData,
      totalEmployees: totalEmployees,
      presentEmployees: no_of_emp_present,
      absentEmployees: no_of_emp_Absent,
      halfDayEmployees: no_of_emp_halfDay,
      is_submit: false,
      selectedBulkMark: null,
    });
  }

  markAllAttendance = (statusValue) => {
    let label = "Present";
    if (statusValue === 0) {
      label = "Leave";
    } else if (statusValue === 1) {
      label = "Present";
    } else if (statusValue === 2) {
      label = "Half Day";
    }

    const employeeAttendanceData = this.state.getEmployeesAttendanceStatus.map((item) => ({
      ...item,
      value: statusValue,
      label,
    }));

    const totalEmployees = employeeAttendanceData.length;
    const no_of_emp_present = employeeAttendanceData.filter((item) => item.value === 1).length;
    const no_of_emp_Absent = employeeAttendanceData.filter((item) => item.value === 0).length;
    const no_of_emp_halfDay = employeeAttendanceData.filter((item) => item.value === 2).length;

    this.setState({
      getEmployeesAttendanceStatus: employeeAttendanceData,
      totalEmployees,
      presentEmployees: no_of_emp_present,
      absentEmployees: no_of_emp_Absent,
      halfDayEmployees: no_of_emp_halfDay,
      is_submit: false,
      selectedBulkMark: statusValue,
    });
  };

  articlecolumns = [
    {
      dataField: "slno",
      text: "S.No",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      headerStyle: { width: "80px", textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      dataField: "employee_name",
      text: "Employee Name",
    },
    {
      dataField: "emp_mobile",
      text: "Mobile",
    },
    {
      dataField: "employee_role",
      text: "Role",
      isDummyField: true,
      formatter: (cell, row) => {
        const roles = this.props.employee_roles || this.state.employee_roles || [];
        const selectedRole = roles.find((r) => r.id == this.state.role);
        return selectedRole ? selectedRole.role_name : "";
      }
    },
    {
      dataField: "attendance_status",
      text: "Attendance Status",
      formatter: this.present.bind(this),
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
  ];

  renderStatCard(label, value, color, icon) {
    return (
      <Col xs={6} md={3} className="mb-3">
        <div
          style={{
            background: "#fff",
            border: "1px solid #e2e8f0",
            borderRadius: 12,
            padding: "16px 18px",
            display: "flex",
            alignItems: "center",
            gap: 14,
            height: "100%",
          }}
        >
          <span
            style={{
              width: 44,
              height: 44,
              borderRadius: 12,
              background: `${color}1a`,
              color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 18,
              flexShrink: 0,
            }}
          >
            <i className={icon} />
          </span>
          <div>
            <div style={{ fontSize: 22, fontWeight: 800, color: "#0f172a", lineHeight: 1 }}>
              {value}
            </div>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#64748b", marginTop: 4 }}>
              {label}
            </div>
          </div>
        </div>
      </Col>
    );
  }

  renderConfirm() {
    const {
      totalEmployees,
      presentEmployees,
      absentEmployees,
      halfDayEmployees,
      date,
      saving,
      saved,
      saveError,
    } = this.state;

    const rows = [
      { label: "Total Employees", value: totalEmployees, color: "#6366f1", icon: "fal fa-users" },
      { label: "Present", value: presentEmployees, color: "#10b981", icon: "fal fa-user-check" },
      { label: "Leave", value: absentEmployees, color: "#ef4444", icon: "fal fa-user-times" },
      { label: "Half Day", value: halfDayEmployees, color: "#f59e0b", icon: "fal fa-user-clock" },
    ];

    return (
      <div style={{ maxWidth: 480, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 18 }}>
          <h3 style={{ fontSize: 16, fontWeight: 800, color: "#0f172a", margin: 0 }}>
            Confirm Attendance
          </h3>
          {date ? (
            <div style={{ fontSize: 13, color: "#64748b", marginTop: 4 }}>
              {moment(date, "YYYY-MM-DD").format("DD MMM YYYY")}
            </div>
          ) : null}
        </div>

        {saving || saved ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "40px 0",
              gap: 16,
            }}
          >
            {saved ? (
              <>
                <i className="fal fa-check-circle" style={{ fontSize: 48, color: "#10b981" }} />
                <div style={{ fontSize: 15, fontWeight: 700, color: "#059669" }}>
                  Attendance saved successfully
                </div>
              </>
            ) : (
              <>
                <span className="spinner-border" style={{ color: "#6366f1", width: 44, height: 44 }} />
                <div style={{ fontSize: 15, fontWeight: 700, color: "#334155" }}>
                  Saving attendance...
                </div>
              </>
            )}
          </div>
        ) : (
          <>
            {rows.map((row) => (
              <div
                key={row.label}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "12px 14px",
                  border: "1px solid #e2e8f0",
                  borderRadius: 10,
                  marginBottom: 10,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <span
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: 10,
                      background: `${row.color}1a`,
                      color: row.color,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 15,
                    }}
                  >
                    <i className={row.icon} />
                  </span>
                  <span style={{ fontSize: 14, fontWeight: 600, color: "#334155" }}>
                    {row.label}
                  </span>
                </div>
                <span style={{ fontSize: 20, fontWeight: 800, color: "#0f172a" }}>
                  {row.value}
                </span>
              </div>
            ))}

            {saveError ? (
              <div style={{ textAlign: "center", color: "#dc2626", fontSize: 13, margin: "12px 0 0" }}>
                {saveError}
              </div>
            ) : null}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 18 }}>
              <button
                type="button"
                onClick={() => this.setState({ view: "mark", saveError: "" })}
                style={{
                  background: "#fff",
                  border: "1px solid #e2e8f0",
                  color: "#475569",
                  borderRadius: 8,
                  padding: "10px 20px",
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <i className="fal fa-arrow-left mr-2" />
                Back
              </button>
              <button
                type="button"
                onClick={this.handleConfirmSave}
                style={{
                  background: "linear-gradient(135deg, rgb(99, 102, 241), rgb(139, 92, 246))",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 22px",
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  boxShadow: "0 4px 12px rgba(99, 102, 241, 0.25)",
                }}
              >
                <i className="fal fa-check mr-2" />
                Confirm &amp; Save
              </button>
            </div>
          </>
        )}
      </div>
    );
  }

  renderShimmer() {
    const cols = [60, 200, 130, 150, 160];
    return (
      <>
        <style>{`
          @keyframes shimmer {
            0%   { background-position: -800px 0; }
            100% { background-position:  800px 0; }
          }
          .ea-shimmer {
            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
            background-size: 800px 100%;
            animation: shimmer 1.4s infinite linear;
            border-radius: 5px;
          }
        `}</style>

        {/* stat card shimmers */}
        <Row>
          {[1, 2, 3, 4].map((c) => (
            <Col key={c} xs={6} md={3} className="mb-3">
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: 12,
                  padding: "16px 18px",
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                }}
              >
                <div className="ea-shimmer" style={{ width: 44, height: 44, borderRadius: 12, flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div className="ea-shimmer" style={{ height: 18, width: 50, marginBottom: 8 }} />
                  <div className="ea-shimmer" style={{ height: 11, width: 90 }} />
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* search bar shimmer */}
        <div style={{ margin: "8px 0 14px" }}>
          <div className="ea-shimmer" style={{ height: 34, width: 220, borderRadius: 8 }} />
        </div>

        {/* table header shimmer */}
        <div style={{ display: "flex", gap: 10, padding: "10px 0", borderBottom: "2px solid #f3f4f6", marginBottom: 4 }}>
          {cols.map((w, i) => (
            <div key={i} className="ea-shimmer" style={{ height: 13, width: w, flexShrink: 0 }} />
          ))}
        </div>

        {/* table row shimmers */}
        {[1, 2, 3, 4, 5, 6].map((row) => (
          <div
            key={row}
            style={{ display: "flex", gap: 10, padding: "13px 0", borderBottom: "1px solid #f3f4f6", alignItems: "center" }}
          >
            {cols.map((w, i) => (
              <div key={i} className="ea-shimmer" style={{ height: 12, width: w, flexShrink: 0 }} />
            ))}
          </div>
        ))}
      </>
    );
  }

  render() {
    const {
      branchError,
      date,
      currentDate,
      loadingSpinner,
      is_submit,
      getEmployeesAttendanceStatus,
      totalEmployees,
      presentEmployees,
      absentEmployees,
      halfDayEmployees,
      defaultvalue,
      view,
    } = this.state;
    const hasData = getEmployeesAttendanceStatus.length > 0;
    const { embedded, onClose } = this.props;

    const labelStyle = {
      display: "block",
      fontSize: 12,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: 0.3,
      color: "#64748b",
      marginBottom: 6,
    };
    const inputStyle = {
      border: "1px solid #e2e8f0",
      borderRadius: 8,
      padding: "9px 12px",
      fontSize: 14,
      color: "#0f172a",
      background: "#fff",
      width: "100%",
    };
    const primaryBtn = {
      background: "linear-gradient(135deg, rgb(99, 102, 241), rgb(139, 92, 246))",
      color: "#fff",
      border: "none",
      padding: "10px 22px",
      borderRadius: 8,
      fontSize: 13,
      fontWeight: 700,
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      boxShadow: "0 4px 12px rgba(99, 102, 241, 0.25)",
    };

    return (
      <div
        style={
          embedded
            ? { padding: 0 }
            : {
              background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
              minHeight: "100vh",
              padding: "20px 16px",
              marginBottom: 80,
            }
        }
      >
        <div
          style={{
            background: "#fff",
            borderRadius: embedded ? 0 : 16,
            boxShadow: embedded ? "none" : "0 4px 24px rgba(0,0,0,0.05)",
            overflow: "hidden",
            border: embedded ? "none" : "1px solid #e2e8f0",
          }}
        >
          {/* ── Header ─────────────────────────────────────────────── */}
          <div
            style={{
              background: "#f8fafc",
              borderBottom: "1.5px solid #e2e8f0",
              padding: "16px 24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 12,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 11,
                  background: "linear-gradient(135deg, rgb(99, 102, 241), rgb(139, 92, 246))",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 17,
                }}
              >
                <i className="fal fa-user-clock" />
              </span>
              <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: "#0f172a" }}>
                Employee Attendance
              </h2>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: "#64748b" }}>Date</span>
                <input
                  type="date"
                  value={date}
                  onChange={this.selDate}
                  max={currentDate}
                  style={{
                    border: "1px solid #e2e8f0",
                    borderRadius: 8,
                    padding: "8px 12px",
                    fontSize: 14,
                    color: "#0f172a",
                    background: "#fff",
                  }}
                />
              </div>
              {embedded && onClose ? (
                <button
                  type="button"
                  onClick={onClose}
                  aria-label="Close"
                  style={{
                    background: "#fff",
                    border: "1px solid #e2e8f0",
                    color: "#475569",
                    width: 34,
                    height: 34,
                    borderRadius: 9,
                    cursor: "pointer",
                    fontSize: 15,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <i className="fal fa-times" />
                </button>
              ) : null}
            </div>
          </div>

          {/* ── Body ───────────────────────────────────────────────── */}
          <div style={{ padding: 24 }}>
            {view === "confirm" ? (
              this.renderConfirm()
            ) : (
              <>
                {/* Filters */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    gap: 16,
                    flexWrap: "wrap",
                    marginBottom: 24,
                  }}
                >
                  {/* No Branch picker — the header's branch selection scopes who is listed. */}
                  {branchError ? (
                    <div style={{ color: "#dc2626", fontSize: 12, marginTop: 4 }}>
                      {branchError}
                    </div>
                  ) : null}
                  {/* <div style={{ flex: "0 1 280px", minWidth: 220 }}>
                    <label style={labelStyle}>Role</label>
                    <select
                      name="role"
                      value={this.state.role}
                      onChange={this.handleInputChange}
                      style={inputStyle}
                    >
                      <option value="">Select Role</option>
                      {(this.props.employee_roles || this.state.employee_roles || []).map((roleData) => (
                        <option key={roleData.id} value={roleData.id}>
                          {roleData.role_name}
                        </option>
                      ))}
                    </select>
                    {this.state.roleError ? (
                      <div style={{ color: "#dc2626", fontSize: 12, marginTop: 4 }}>
                        {this.state.roleError}
                      </div>
                    ) : null}
                  </div> */}

                  <button onClick={() => this.getEmployeesAttendanceStatus()} style={primaryBtn}>
                    {loadingSpinner == 1 ? (
                      <Spinner animation="border" size="sm" className="mr-2" />
                    ) : (
                      <i className="fal fa-search mr-2" />
                    )}
                    Get Employees
                  </button>
                </div>

                {/* Shimmer while loading → stat cards + table → empty state */}
                {loadingSpinner == 1 ? (
                  this.renderShimmer()
                ) : hasData ? (
                  <>
                    <Row>
                      {this.renderStatCard("Total Employees", totalEmployees, "#6366f1", "fal fa-users")}
                      {this.renderStatCard("Present", presentEmployees, "#10b981", "fal fa-user-check")}
                      {this.renderStatCard("Leave", absentEmployees, "#ef4444", "fal fa-user-times")}
                      {this.renderStatCard("Half Day", halfDayEmployees, "#f59e0b", "fal fa-user-clock")}
                    </Row>

                    <div
                      style={{
                        background: "#fff7ed",
                        border: "1px solid #fed7aa",
                        color: "#9a3412",
                        borderRadius: 10,
                        padding: "10px 14px",
                        fontSize: 13,
                        fontWeight: 600,
                        margin: "8px 0 16px",
                      }}
                    >
                      <i className="fal fa-info-circle mr-2" />
                      By default all employees are marked Present. Use the dropdown to mark
                      Leave / Half Day.
                    </div>

                    <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap" style={{ gap: "16px" }}>
                      <div className="d-flex align-items-center" style={{ gap: "10px", flexWrap: "wrap" }}>
                        <span style={{ fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Mark All As:</span>
                        <button
                          type="button"
                          onClick={() => this.markAllAttendance(1)}
                          style={{
                            padding: "6px 14px",
                            borderRadius: "8px",
                            border: this.state.selectedBulkMark === 1 ? "1px solid #059669" : "1px solid #10b981",
                            background: this.state.selectedBulkMark === 1 ? "#10b981" : "#f0fdf4",
                            color: this.state.selectedBulkMark === 1 ? "#ffffff" : "#10b981",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor: "pointer",
                            transition: "all 0.15s ease",
                            outline: "none",
                          }}
                        >
                          <i className="fas fa-check mr-2" /> Present
                        </button>
                        <button
                          type="button"
                          onClick={() => this.markAllAttendance(0)}
                          style={{
                            padding: "6px 14px",
                            borderRadius: "8px",
                            border: this.state.selectedBulkMark === 0 ? "1px solid #dc2626" : "1px solid #ef4444",
                            background: this.state.selectedBulkMark === 0 ? "#ef4444" : "#fef2f2",
                            color: this.state.selectedBulkMark === 0 ? "#ffffff" : "#ef4444",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor: "pointer",
                            transition: "all 0.15s ease",
                            outline: "none",
                          }}
                        >
                          <i className="fas fa-times mr-2" /> Leave
                        </button>
                        <button
                          type="button"
                          onClick={() => this.markAllAttendance(2)}
                          style={{
                            padding: "6px 14px",
                            borderRadius: "8px",
                            border: this.state.selectedBulkMark === 2 ? "1px solid #d97706" : "1px solid #f59e0b",
                            background: this.state.selectedBulkMark === 2 ? "#f59e0b" : "#fffbeb",
                            color: this.state.selectedBulkMark === 2 ? "#ffffff" : "#f59e0b",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor: "pointer",
                            transition: "all 0.15s ease",
                            outline: "none",
                          }}
                        >
                          <i className="fas fa-clock mr-2" /> Half Day
                        </button>
                      </div>

                      <div className="d-flex align-items-center" style={{ gap: "16px", background: "#f8fafc", padding: "6px 16px", borderRadius: "10px", border: "1.5px solid #e2e8f0", height: "38px" }}>
                        <span style={{ fontSize: "11px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", color: "#64748b" }}>Status Indicators:</span>
                        <div className="d-flex align-items-center" style={{ gap: "8px", fontSize: "12px", fontWeight: "600", color: "#334155" }}>
                          <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "20px", height: "20px", borderRadius: "50%", background: "#10b981", color: "#fff", fontSize: "10px" }}><i className="fas fa-check" /></span>
                          <span>Present</span>
                        </div>
                        <div className="d-flex align-items-center" style={{ gap: "8px", fontSize: "12px", fontWeight: "600", color: "#334155" }}>
                          <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "20px", height: "20px", borderRadius: "50%", background: "#ef4444", color: "#fff", fontSize: "10px" }}><i className="fas fa-times" /></span>
                          <span>Leave</span>
                        </div>
                        <div className="d-flex align-items-center" style={{ gap: "8px", fontSize: "12px", fontWeight: "600", color: "#334155" }}>
                          <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "20px", height: "20px", borderRadius: "50%", background: "#f59e0b", color: "#fff", fontSize: "10px" }}><i className="fas fa-clock" /></span>
                          <span>Half Day</span>
                        </div>
                      </div>
                    </div>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                      <CardLessDataTable
                        parentData={getEmployeesAttendanceStatus}
                        particlecolumns={this.articlecolumns}
                        name="attendance"
                        searchBar={true}
                      />
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                      <button
                        onClick={() => this.setState({ view: "confirm", saveError: "" })}
                        style={primaryBtn}
                      >
                        <i className="fal fa-check-circle mr-2" />
                        Submit Attendance
                      </button>
                    </div>
                  </>
                ) : is_submit ? (
                  <div style={{ textAlign: "center", padding: "56px 0", color: "#64748b" }}>
                    <i className="fal fa-inbox" style={{ fontSize: 42, color: "#cbd5e1" }} />
                    <p style={{ marginTop: 12, fontSize: 14, fontWeight: 600 }}>
                      No Data Available
                    </p>
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withApollo(compose()(EmployeeAttendanceSection)));
